// components/Testimonials.js
import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import '../components/Testimonials.css'; // Import your CSS file

function Testimonials() {
  return (
    <section id="testimonials" className="py-5">
      <Container>
        <h2 className="text-center mb-5">Client Testimonials</h2>
        <Row>
          <Col md={4} className="text-center mb-4">
            <Image 
              src="https://img.freepik.com/premium-photo/3d-portrait-illustration-business-man_136974-18.jpg" 
              roundedCircle 
              className="testimonial-img mb-3"
              width={150}
              height={150}
            />
            <blockquote className="blockquote">
              <p>"Westron delivered an outstanding app that exceeded our expectations."</p>
              <footer className="blockquote-footer">John Doe, CEO.</footer>
            </blockquote>
          </Col>
          <Col md={4} className="text-center mb-4">
            <Image 
              src="https://img.freepik.com/premium-photo/man-stands-dark-street-with-green-jacket-green-jacket_542670-12167.jpg" 
              roundedCircle 
              className="testimonial-img mb-3"
              width={150}
              height={150}
            />
            <blockquote className="blockquote">
              <p>"The team at Westron is professional, creative, and efficient."</p>
              <footer className="blockquote-footer">Jane Smith, CTO.</footer>
            </blockquote>
          </Col>
          <Col md={4} className="text-center mb-4">
            <Image 
              src="https://img.freepik.com/premium-photo/woman-stands-dark-street-with-lights-her_542670-4812.jpg" 
              roundedCircle 
              className="testimonial-img mb-3"
              width={150}
              height={150}
            />
            <blockquote className="blockquote">
              <p>"We couldn't be happier with the results of our collaboration with Westron."</p>
              <footer className="blockquote-footer">Linda Johnson, Founder.</footer>
            </blockquote>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Testimonials;
